module.exports = __webpack_public_path__ + "static/media/logo-name-thin.0453b5a1.svg";